import { useEffect, useState } from 'react';
import { useAuthStore } from '../stores/authStore';
import { firestoreService, collectionRefs } from '../firebase/firestore';

export const useUserData = () => {
  const { user } = useAuthStore();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) return;

    const fetchUserData = async () => {
      setLoading(true);
      try {
        const data = await firestoreService.read(collectionRefs.users, user.uid);
        setUserData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [user]);

  return { userData, loading, error };
};
